import React, { useState, useEffect } from 'react';
import { Container, makeStyles } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import Page from 'src/shared/ui/components/Page';
import Datatable from 'src/shared/ui/components/Datatable';
import getCustomerList from 'src/customer/use-cases/getCustomerList';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const CustomerListView = (props) => {
  console.log(props);

  const classes = useStyles();

  const [list, setList] = useState({
    rows: [],
    count: 0
  });
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [orderBy, setOrderBy] = useState({
    columnName: null,
    orderBy: null
  });

  const navigate = useNavigate();

  const fetchList = async () => {
    const companyHeadquarterId = localStorage.selectedUserHeadquarter;
    const response = await getCustomerList({
      companyHeadquarterId,
      search,
      orderBy: orderBy.columnName
        ? `${orderBy.columnName} ${orderBy.orderBy}`
        : '',
      page,
      limit
    });

    setList(response);
  };

  useEffect(() => {
    fetchList();
  }, [page, limit, search, orderBy]);

  const handleSearch = (searchValue) => {
    setPage(0);
    setSearch(searchValue.target.value);
  };

  const handleChangePage = (pageIndex) => {
    setPage(pageIndex);
  };

  const handleChangeLimit = (limitIndex) => {
    setLimit(limitIndex);
  };

  const handleOrderBy = (column) => {
    setOrderBy(column);
  };

  const handleClickEdit = (event, id) => {
    navigate(`/app/customers/${id}`, {
      replace: false
    });
  };

  const columnNameList = [
    'createdAt',
    'status',
    'contactPlannedAt',
    "${'CL'}${customerCode}",
    'CustomerType.code',
    'businessName',
    'document',
    '${UserCreator.firstname}${UserCreator.surnames}'
  ];

  if (localStorage.selectedUserHeadquarter === 'all') {
    columnNameList.unshift('CompanyHeadquarter.name');
  }

  return (
    <Page className={classes.root} title="Clientes">
      <Container maxWidth={false}>
        <Datatable
          domainName="CUSTOMER"
          dataList={list.rows}
          count={list.count}
          addButtonText="Añadir cliente"
          addButtonRoute="/app/customers/new"
          title="Clientes"
          exportExcelButton={Boolean(false)}
          onSearch={handleSearch}
          onChangePageValue={handleChangePage}
          onChangePageLimit={handleChangeLimit}
          handleOrderBy={handleOrderBy}
          handleClickEdit={handleClickEdit}
          columnNameList={columnNameList}
        />
      </Container>
    </Page>
  );
};

export default CustomerListView;
